import nBossConnection from 'modules/base/service/nBossConnection';

class VizsgaService {
	constructor() {
		this.connection = nBossConnection.connection;
		this.CONTROL = 'vizsgaControl';
	}

	/**
	 * @return {Promise<any>}
	 */
	getUnLockedSelection() {
		return new Promise((resolve, reject) => {
			this.connection
				.get(`/${this.CONTROL}/getUnLockedSelection`)
				.then(response => resolve(response.data))
				.catch(reject);
		});
	}
}

export default new VizsgaService();
